import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {HelperService} from "app/lib/helper.service";
import {ChartParams} from "../../views/chart/chart.component";
import { SitesService } from "../sites.service";
import {  IStatResult } from "../../models/responce_result.model";

interface IWidgetSearchStats extends IStatResult {
	searchCount: number;
	userCount: number;
}

@Component({
	selector: 'widget-search',
	templateUrl: './widget_search.component.html'
})
export class WidgetSearchComponent extends BaseComponent {
	searchCount: number = 0;
	userCount: number = 0;
	stats: any[] = [];
	
	statsLoader: boolean =  false;
	paginationLoader: boolean =  false;

	chart = new ChartParams();

	addFilterParams = {
		userType    : 'user',
		dateFilters : ['dateWidgetSearch', 'dateCreated', 'dateSiteCreated']
	};

	totalPages: any = 1;
	currentPage: number = 1;

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public filter: FilterFormService,
		public http: HttpClient,
		public helper: HelperService,
		public siteService: SitesService,
	) {
		super(eventsService, siteService, activatedRoute, filter, translate);

		this.chart.setOptions({
			names: {
				'countToUser': this.translate.__A('widgetSearch.countToUser'),
				'totalCount': this.translate.__A('common.total сount')
			}
		});
	}

	async getData() {
		await this.getChart();
		await this.getStats();
		await this.getPagination();
	}


	async getChart() {
		this.chart.showLoader();

		const { charts } = await this.siteService.widgetSearch.chart(
			this.filter.filterParams
		).toPromise();
		this.chart.data = charts;

		this.chart.hideLoader();
	}
	
	
	async getStats() {
		this.statsLoader = true;
		
		const { stats, searchCount, userCount } = await this.siteService.widgetSearch.stats<IWidgetSearchStats>(
			this.filter.filterParams
		).toPromise();
		
		this.searchCount = searchCount;
		this.userCount   = userCount;
		this.stats       = stats;
		
		this.statsLoader = false;
	}

	async getPagination() {
		const pagination = await this.siteService.widgetSearch.pagination(
			this.filter.filterParams
		).toPromise();
		
		this.pagination.fill(pagination);
	}


	async onPageChange() {
		this.filter.filterParams.page = this.pagination.page;
		await this.getStats();
	}
}
